import { Component } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { FlexDirective } from '@ngbracket/ngx-layout/flex';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-damwain-cerbyd-arall',
    templateUrl: './damwain-cerbyd-arall.component.html',
    styleUrls: ['./damwain-cerbyd-arall.component.scss'],
    imports: [FlexDirective, FaIconComponent, MatButton, FormlyModule, TranslatePipe]
})
export class DamwainCerbydArallComponent extends FieldArrayType {

  constructor() {
    super();
  }
}
